export const ADD_TITLE_IN_TITLE_LIST = "ADD_TITLE_IN_TITLE_LIST"
export const EDIT_TITLE_FIELD = "EDIT_TITLE_FIELD"
export const EDIT_TITLES_OTHER_INFORMATIONS = "EDIT_TITLES_OTHER_INFORMATIONS"
export const REMOVE_TITLE_FROM_TITLE_LIST = "REMOVE_TITLE_FROM_TITLE_LIST"
export const RESET_TITLES = "RESET_TITLES"
